<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="contact1">
					<div class="contact1-map fl">
						<baidu-map class="map" 
						:center="center" :zoom="zoom" @ready="handler" 
						style="width: 100%;height: 100%;">
							
						</baidu-map>
						<img src="../assets/images/mapxxx.png" alt="">
					</div>
					<div class="contact1-con">
						<div class="contact1-title">
							<h1>{{this.settingObj.title}}</h1>
							<h2>{{this.settingObj.description}}</h2>
						</div>
						<div class="contact1-dl">
							<dl>
								<dd>地址：{{this.settingObj.address}}</dd>
								<dd>电话：{{this.settingObj.tel}}</dd>
								<dd>传真：{{this.settingObj.fax}}</dd>
								<dd>邮箱：{{this.settingObj.email}}</dd>
							</dl>
						</div>
						<div class="contact1-er">
							<div class="contact1-er-img fl">
								<img :src="icoURL+'storage/'+settingObj.wechat" alt="">
							</div>
							<div class="contact1-er-con">
								欲了解我们更多资讯<br />
								请扫码添加官方微信
							</div>
							<div class="clear"></div>
						</div>
					</div>
					<div class="clear"></div>
				</div>
				<div class="contact2">
					<div class="contact2-li" :class="{'has-error': classObject.titleClass.hasError}">
						<input type="text" class="form-control" placeholder="留言标题" v-model="dataObj.title" 
						@focus='classObject.titleClass.hasError = false'>
					</div>
					<div class="contact2-ts" v-show="classObject.titleClass.hasError">请输入留言标题</div>
					<div class="contact2-li" :class="{'has-error': classObject.contentClass.hasError}">
						<textarea class="form-control" placeholder="留言内容" v-model="dataObj.content" 
						@focus='classObject.contentClass.hasError = false'></textarea>
					</div>
					<div class="contact2-ts" v-show="classObject.contentClass.hasError">请输入留言内容</div>
					<div class="contact2-li" :class="{'has-error': classObject.emailClass.hasError}">
						<input type="text" class="form-control" placeholder="联系邮箱" v-model="dataObj.email" 
						@focus='classObject.emailClass.hasError = false'>
					</div>
					<div class="contact2-ts" v-show="classObject.emailClass.hasError">请输入正确的邮箱格式</div>
					<div class="contact2-li contact2-li-yzm" :class="{'has-error': classObject.captchaClass.hasError}">
						<input type="text" class="form-control" placeholder="验证码" v-model="dataObj.captcha" 
						@focus='classObject.captchaClass.hasError = false' id="code_input">
						<div id="contact2-li-yzm-img"></div>
					</div>
					<div class="contact2-ts" v-show="classObject.captchaClass.hasError">请输入验证码</div>
					<div class="contact2-btn">
						<input type="button" class="btn btn-primary" value="提交" @click="res_postData()">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/js/gVerify.js';
	export default{
		name:'contentus',
		data(){
			return{
				title:'',
				titleEn:'',
				setting:{},
				settingObj:{
					copyright:'',
					icp:'',
					address:'',
					tel:'',
					fax:'',
					email:'',
					wechat:'',
					title:'',
					description:''
				},
				center: {lng: 109.511294, lat: 34.491603},  //经纬度
				zoom: 20,//地图展示级别
				verifyCode:{},
				dataObj:{
					title:'',
					content:'',
					email:'',
					captcha:''
				},
				classObject:{
					titleClass: {hasError: false},
					contentClass: {hasError: false},
					emailClass: {hasError: false},
					captchaClass: {hasError: false}
				}
				
			}
		},
		methods:{
			handler ({BMap, map}) {
				map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
				//添加缩放平移控件
				map.addControl(new BMap.NavigationControl());
				//添加比例尺控件
				map.addControl(new BMap.ScaleControl());
				
				var point = new BMap.Point(this.center.lng, this.center.lat);
				map.centerAndZoom(point, 20);
				var myIcon = new BMap.Icon("/images/dw.png", new BMap.Size(20,25));
				 myIcon.setImageSize(new BMap.Size(20,25));//设置图标大小
				var marker = new BMap.Marker(point,{icon:myIcon});
				map.addOverlay(marker);
				
				var opts = {
						width : 330,     // 信息窗口宽度
						height: 100,     // 信息窗口高度
						title : "陕西省一三九煤田地质水文地质有限公司" , // 信息窗口标题
				}
				var infoWindow = new BMap.InfoWindow("地址：陕西省渭南市站北路6号<br />电话：0913-2154209", opts);  // 创建信息窗口对象 
				marker.addEventListener("click", function(){          
					map.openInfoWindow(infoWindow, point); //开启信息窗口
				}); 
			},
			res_menuClass(e){
				this.axios.get('/api/menus/class?id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.title = response.data.reslut.name;
							this.titleEn = response.data.reslut.sub_title;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_setting(){
				this.axios.get('/api/setting')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.menus = response.data.reslut;
							this.setting = response.data.reslut;
							this.setting.forEach(item=>{
								if(item.key == "xsjgw.copyright"){
									this.settingObj.copyright = item.value;
								}
								if(item.key == "xsjgw.icp"){
									this.settingObj.icp = item.value;
								}
								if(item.key == "xsjgw.address"){
									this.settingObj.address = item.value;
								}
								if(item.key == "xsjgw.tel"){
									this.settingObj.tel = item.value;
								}
								if(item.key == "xsjgw.fax"){
									this.settingObj.fax = item.value;
								}
								if(item.key == "xsjgw.email"){
									this.settingObj.email = item.value;
								}
								if(item.key == "xsjgw.wechat"){
									this.settingObj.wechat = item.value;
								}
								if(item.key == "xsjgw.title"){
									this.settingObj.title = item.value;
								}
								if(item.key == "xsjgw.description"){
									this.settingObj.description = item.value;
								}
							}) 
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_postData(){  
				if(this.paramsValidate(this.dataObj)){
					if(this.email(this.dataObj.email)){
						this.classObject.emailClass.hasError = false
						// console.log('verifyCode',this.verifyCode)
						var ress = this.verifyCode.validate(document.getElementById("code_input").value);
						if(ress){
							this.classObject.captchaClass.hasError = false
							console.log("验证正确");
							console.log('提交字段',this.dataObj);
							this.axios({
								method:'post',
								url:'/api/sendMessage',
								params:this.dataObj,
								}).then(response => {
									// 处理成功情况
									alert(response.data.message);
									if(response.data.code == 200){
										this.dataObj.title = ""
										this.dataObj.content = ""
										this.dataObj.email = ""
										this.dataObj.captcha = ""
									}
									
								})
								.catch(error => {
									// 处理错误情况
									console.log('错误提示:',error);
								})
						}else{
							this.classObject.captchaClass.hasError = true
							return
						}
					}else{
						console.log("邮箱格式错误");
						this.classObject.emailClass.hasError = true
					}
				}
			},
			//验证提交字段非空
			paramsValidate (params) {
				let flag = true;
			 
				for(var key in params){
					if(params[key] != '0' && !params[key]){
						console.log(params)
						if(params.title == ''){
							this.classObject.titleClass.hasError = true
						}else{
							this.classObject.titleClass.hasError = false;
						}
						if(params.content == ''){
							this.classObject.contentClass.hasError = true
						}else{
							this.classObject.contentClass.hasError = false;
						}
						if(params.email == ''){
							this.classObject.emailClass.hasError = true
						}else{
							this.classObject.emailClass.hasError = false;
						}
						if(params.captcha == ''){
							this.classObject.captchaClass.hasError = true
						}else{
							this.classObject.captchaClass.hasError = false;
						}
						console.log('请完善数据!');
						return false; // 终止程序
					}
				}                            
				this.classObject.titleClass.hasError = false;
				this.classObject.contentClass.hasError = false;
				this.classObject.emailClass.hasError = false;
				this.classObject.captchaClass.hasError = false;
				return flag;
			},
			/**
			 * 验证电子邮箱格式
			 */
			email(value) {
			    return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value)
			}
		},
		created(){
			this.res_menuClass(this.$route.query.category_id)
			this.res_setting();
			this.$nextTick(function () {
				this.verifyCode = new GVerify({
					id:'contact2-li-yzm-img',
					canvasId:'contact2-li-canvas'
				});
			})
		},
		mounted(){

		}
	}
</script>

<style>
</style>